export default () => {
  const init = () => {
  };

  init();
};